import { getBehavior, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { isHotKeyPress } from '@/utils/event-kit';
import { ILayerProps, LayerType } from '@/version-types';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (disabled || !activeLayer) return null;

    const item = {
        name: $t((v) => v.contextMenuLayer.menuConfig.overlap),
        type: 'overlap',
        childMenus: [] as any[],
    } as any;

    // 生成一个组，并激活
    const generateGroupAndActive = (layer: ILayerProps, currentLayer: ILayerProps) => {
        if (currentLayer.lock || currentLayer.hidden) return;
        const parentLayer = framework.getWrapLayer(currentLayer.id, true);
        if (!parentLayer) return;
        if (layer.id === parentLayer.id || layer.id === currentLayer.id) {
            framework.operate.setActiveLayer(currentLayer.id);
            return;
        }
        // 锁定的图层和组内自身图层不作处理
        let pickIds: string[] = [];
        // 临时组时加入处理
        if (framework.checkIsExtraGroup(layer)) {
            framework.getInstance(ContextMenuPluginDependency).unpack(layer.id);
            pickIds = layer.children.map((child) => child.id);
        } else {
            pickIds = [layer.id];
        }
        framework.getInstance(ContextMenuPluginDependency).createGroupAndActive([...pickIds, parentLayer.id]);
    };

    const layerOverlapData = framework.getLayerOverLapList(activeLayer.id);

    const genMenuListLayer = (layers: ILayerProps[], isRoot, style = {}) => {
        layers.forEach((layer) => {
            const { id, layerType, children } = layer;
            const name = getBehavior(framework.identity, layer)?.getMenuOverlapName?.(layer) || '';
            const layerLevel = {
                style,
                name,
                type: layer.id,
                active: activeLayer.id === layer.id,
                icon: getBehavior(framework.identity, layer)?.getMenuOverlapIcon?.(layer),
                onClick: () => {
                    // console.log(layer.id);
                    const hotKeyDown = isHotKeyPress();
                    if (hotKeyDown) {
                        if (activeLayer) {
                            generateGroupAndActive(activeLayer, layer);
                        }
                    } else {
                        if (layer.hidden) return;
                        framework.operate.setActiveLayer(id);
                    }
                },
                onMouseEnter: () => {
                    framework.operate.setSelected(id);
                },
                onMouseLeave: () => {
                    framework.operate.clearSelected();
                },
            };
            if (layerType === LayerType.GROUP_LAYER) {
                if (isRoot) {
                    item.childMenus.push(layerLevel);
                }
                genMenuListLayer(children, false, { paddingLeft: 38 });
            } else {
                item.childMenus.push(layerLevel);
            }
        });
    };
    genMenuListLayer(layerOverlapData, true);

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 3,
    sort: 3,
    render,
} as IExportContextMenuItem;
